// extracted by mini-css-extract-plugin
export default {"ChatListElem_wrap":"Message_ChatListElem_wrap__jdz-8","img":"Message_img__UYSYY","message_wrap":"Message_message_wrap__5pgTO","msg":"Message_msg__ZH6+a"};